export function escapeHtml(str) {
  if (!str) return ''
  const div = document.createElement('div')
  div.textContent = str
  return div.innerHTML
}

export function timeAgo(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const now = new Date()
  const seconds = Math.floor((now - date) / 1000)

  if (seconds < 60) return '< 1 min'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} godz.`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days} dn.`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months} mies.`
  return `${Math.floor(months / 12)} r.`
}

export function formatDate(dateString, style = 'long') {
  if (!dateString) return ''
  const date = new Date(dateString)
  const options = style === 'short'
    ? { day: 'numeric', month: 'short', year: 'numeric' }
    : { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }
  return date.toLocaleDateString('pl-PL', options)
}

export function formatShortDate(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: '2-digit' })
}

export function loadingSkeletonHtml(rows = 3) {
  let html = ''
  for (let i = 0; i < rows; i++) {
    html += `<div class="placeholder-glow mb-3"><span class="placeholder col-8"></span><span class="placeholder col-4"></span><span class="placeholder col-6"></span></div>`
  }
  return html
}

export function paginationHtml(meta) {
  if (!meta || meta.total_pages <= 1) return ''
  const { current_page, total_pages } = meta
  let html = '<nav aria-label="Pagination"><ul class="pagination justify-content-center">'

  if (current_page > 1) {
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${current_page - 1}">&laquo;</a></li>`
  }

  const start = Math.max(1, current_page - 3)
  const end = Math.min(total_pages, current_page + 3)

  if (start > 1) {
    html += '<li class="page-item"><a class="page-link" href="#" data-page="1">1</a></li>'
    if (start > 2) html += '<li class="page-item disabled"><span class="page-link">...</span></li>'
  }

  for (let i = start; i <= end; i++) {
    const active = i === current_page ? ' active' : ''
    html += `<li class="page-item${active}"><a class="page-link" href="#" data-page="${i}">${i}</a></li>`
  }

  if (end < total_pages) {
    if (end < total_pages - 1) html += '<li class="page-item disabled"><span class="page-link">...</span></li>'
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${total_pages}">${total_pages}</a></li>`
  }

  if (current_page < total_pages) {
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${current_page + 1}">&raquo;</a></li>`
  }

  html += '</ul></nav>'
  return html
}

let translations = {}

export function loadTranslations(elementId = 'page-translations') {
  const el = document.getElementById(elementId)
  if (el) {
    try { translations = JSON.parse(el.textContent) } catch { /* noop */ }
  }
}

function pluralKey(count) {
  const abs = Math.abs(count)
  if (abs === 1) return 'one'
  const mod10 = abs % 10
  const mod100 = abs % 100
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'few'
  return 'many'
}

export function t(key, params = {}) {
  const keys = key.split('.')
  let value = translations
  for (const k of keys) {
    if (value == null) return key
    value = value[k]
  }
  if (value == null) return key

  if (typeof value === 'object' && params.count != null) {
    const pKey = params.count === 0 ? 'zero' : pluralKey(params.count)
    value = value[pKey] || value['other'] || Object.values(value)[0]
  }

  if (typeof value !== 'string') return key

  return value.replace(/%\{(\w+)\}/g, (_, k) => params[k] ?? '')
}
